<ion-content>
  <ion-list>
    <ion-item lines="none">
      <ion-label position="stacked" *ngIf="popoverType==='default'" class="loadingLabel">
        {{ "humidor-popover-loading.loading-entries" | translate}} 
        ( {{ progress*100 | number: '1.0-0'}} &percnt; )
      </ion-label>
      <ion-label position="stacked" *ngIf="popoverType==='stats'" class="loadingLabel">
        {{ "humidor-popover-loading.loading-stats" | translate}} 
        ( {{ progress*100 | number: '1.0-0'}} &percnt; )
      </ion-label>
      <ion-progress-bar color="secondary" [value]="progress" [buffer]="progress_next">
      </ion-progress-bar>
    </ion-item>
  </ion-list>
</ion-content>